import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { Edit, Refresh, Trash } from 'seagull/icons';
import { getIsNameValid } from '../APIKeysPage.utils';
import { DeactivateAPIKeyModal } from './DeactivateAPIKeyModal';
import GenerateAPIKeyModal from './GenerateAPIKeyModal';
import { RegenerateAPIKeyModal } from './RegenerateAPIKeyModal';
import { RenameAPIKeyModal } from './RenameAPIKeyModal';
const DISMISSIBLE = {
    closeOnClickOutside: true,
    closeOnEscapeKey: true
};
export const showGenerateAPIKeyModal = (param)=>{
    let { overlayContext, keys, refresh } = param;
    return overlayContext.showModal(_object_spread({
        biName: 'generate_api_key_modal',
        content: (param)=>{
            let { dismissModal } = param;
            return /*#__PURE__*/ _jsx(GenerateAPIKeyModal, {
                getIsNameValid: (name)=>getIsNameValid({
                        name,
                        keys
                    }),
                dismissModal: dismissModal,
                refresh: refresh
            });
        }
    }, DISMISSIBLE));
};
const showRegenerateAPIKeyModal = (param, apiKey)=>{
    let { overlayContext, refresh } = param;
    return overlayContext.showModal(_object_spread({
        biName: 'regenerate_api_key_modal',
        content: (param)=>{
            let { dismissModal } = param;
            return /*#__PURE__*/ _jsx(RegenerateAPIKeyModal, {
                apiKey: apiKey,
                dismissModal: dismissModal,
                refresh: refresh
            });
        }
    }, DISMISSIBLE));
};
const showRenameAPIKeyModal = (param, apiKey)=>{
    let { overlayContext, keys, refresh } = param;
    return overlayContext.showModal(_object_spread({
        biName: 'rename_api_key_modal',
        content: (param)=>{
            let { dismissModal } = param;
            return /*#__PURE__*/ _jsx(RenameAPIKeyModal, {
                apiKey: apiKey,
                getIsNameValid: (name)=>getIsNameValid({
                        name,
                        keys,
                        currentName: apiKey.name
                    }),
                dismissModal: dismissModal,
                refresh: refresh
            });
        }
    }, DISMISSIBLE));
};
const showDeactivateAPIKeyModal = (param, apiKey)=>{
    let { overlayContext, refresh } = param;
    return overlayContext.showModal(_object_spread({
        biName: 'deactivate_api_key_modal',
        content: (param)=>{
            let { dismissModal } = param;
            return /*#__PURE__*/ _jsx(DeactivateAPIKeyModal, {
                apiKey: apiKey,
                dismissModal: dismissModal,
                refresh: refresh
            });
        }
    }, DISMISSIBLE));
};
export const toAPIKeyMenuActions = (context, apiKey, texts)=>[
        {
            icon: Refresh,
            label: texts.regenerateApiKeyAction(),
            onClick: ()=>showRegenerateAPIKeyModal(context, apiKey),
            bi: {
                name: 'regenerate_api_key'
            }
        },
        {
            icon: Edit,
            label: texts.renameAction(),
            onClick: ()=>showRenameAPIKeyModal(context, apiKey),
            bi: {
                name: 'rename_api_key'
            }
        },
        {
            icon: Trash,
            label: texts.deactivateApiKeyAction(),
            onClick: ()=>showDeactivateAPIKeyModal(context, apiKey),
            bi: {
                name: 'deactivate_api_key'
            },
            destructive: true
        }
    ];
